export default __webpack_public_path__ + "static/imda20173rdprize-6522e94ebfda3ecd5eca567b0a13ef75.jpg";